import { useMutation, useQueryClient } from '@tanstack/react-query';

import { EmailCreateFormValues } from '../../../../../types';
import { handleError, handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../../logic';
import { ApiErrorResponse } from '../../../../types';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { postCreateApplicationEmail } from '../../requests/postCreateApplicationEmail';

export const useCreateApplicationEmail = (
  uuid: string,
  definitionName: string,
) => {
  const queryClient = useQueryClient();
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: createEmail, ...rest } = useMutation({
    mutationFn: (formValues: EmailCreateFormValues) =>
      postCreateApplicationEmail(
        constructPost,
        uuid,
        definitionName,
        formValues,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [APPLICATION_BASE_PATH, uuid, 'messages'],
      });
      handleSuccess('Message created.');
    },
    onError: (error: ApiErrorResponse) =>
      handleError(
        getApiErrorMessage(
          error,
          'An unknown error occurred while creating the email.',
        ),
      ),
  });

  return { createEmail, ...rest };
};
